import React, { useState, useEffect, useContext } from "react";
import { useParams } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import Button from '@material-ui/core/Button';
import Box from '@material-ui/core/Box';
import BottomNavigation from '@material-ui/core/BottomNavigation';
import BottomNavigationAction from '@material-ui/core/BottomNavigationAction';
import QuestionAnswerIcon from '@material-ui/icons/QuestionAnswer';
import ChatIcon from '@material-ui/icons/Chat';
import ChatBubbleOutlineIcon from '@material-ui/icons/ChatBubbleOutline';

import TicketsManagerTabs from "../../components/TicketsManagerTabs/";
import Ticket from "../../components/Ticket/";
import TicketAdvancedLayout from "../../components/TicketAdvancedLayout";

import { TicketsContext } from "../../context/Tickets/TicketsContext";

import { i18n } from "../../translate/i18n";
import { QueueSelectedProvider } from "../../context/QueuesSelected/QueuesSelectedContext";
import { getTokens } from "../../styles/tokens";

const useStyles = makeStyles(theme => {
    const t = getTokens(theme.palette.type, theme.palette.primary.main);
    const isDark = theme.palette.type === "dark";
    // mesmas faixas da conversa (padrão WhatsApp Web)
    const wa = isDark
        ? { strip: "#202c33", text: "#8696a0", on: "#00a884", empty: "#222e35" }
        : { strip: "#f0f2f5", text: "#54656f", on: "#008069", empty: "#f0f2f5" };
    return {
        header: {
            minWidth: 0,
            borderBottom: `1px solid ${t.line}`,
        },
        nav: {
            height: 48,
            backgroundColor: wa.strip,
        },
        navAction: {
            maxWidth: "none",
            minWidth: 0,
            padding: "0 12px !important",
            color: wa.text,
            borderBottom: "2px solid transparent",
            "& .MuiBottomNavigationAction-wrapper": {
                flexDirection: "row",
                gap: 8,
            },
            "& .MuiSvgIcon-root": {
                fontSize: 20,
            },
            "& .MuiBottomNavigationAction-label": {
                fontSize: "14px !important",
                fontWeight: 500,
            },
            "&.Mui-selected": {
                color: wa.on,
                borderBottomColor: wa.on,
            },
        },
        content: {
            overflow: "auto",
            minHeight: 0,
        },
        // estado vazio no padrão do WhatsApp Web
        placeholderContainer: {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            gap: 8,
            height: "100%",
            padding: 24,
            boxSizing: "border-box",
            textAlign: "center",
            backgroundColor: wa.empty,
        },
        placeholderIcon: {
            fontSize: 56,
            marginBottom: 6,
            color: t.textMuted,
        },
        placeholderTitle: {
            color: t.text,
            fontSize: 20,
            fontWeight: 400,
        },
        placeholderItem: {
            maxWidth: 320,
            marginBottom: 10,
            color: t.textSecondary,
            fontSize: 14,
            lineHeight: 1.5,
        },
    };
});

const TicketAdvanced = (props) => {
    const classes = useStyles();
    const { ticketId } = useParams();
    const [option, setOption] = useState(0);
    const { currentTicket, setCurrentTicket } = useContext(TicketsContext)

    useEffect(() => {
        if (currentTicket.id !== null) {
            setCurrentTicket({ id: currentTicket.id, code: '#open' })
        }
        if (!ticketId) {
            setOption(1)
        }
        return () => {
            setCurrentTicket({ id: null, code: null })
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        if (currentTicket.id !== null) {
            setOption(0)
        }
    }, [currentTicket])

    const renderPlaceholder = () => {
        return <Box className={classes.placeholderContainer}>
            <ChatBubbleOutlineIcon className={classes.placeholderIcon} />
            <div className={classes.placeholderTitle}>Pronto para atender</div>
            <div className={classes.placeholderItem}>{i18n.t("chat.noTicketMessage")}</div>
            <Button onClick={() => setOption(1)} variant="contained" color="primary">
                Ver conversas
            </Button>
        </Box>
    }

    const renderMessageContext = () => {
        if (ticketId && ticketId !== "undefined") {
            return <Ticket />
        }
        return renderPlaceholder()
    }

    const renderTicketsManagerTabs = () => {
        return <TicketsManagerTabs
        />
    }

    return (
        <QueueSelectedProvider>

            <TicketAdvancedLayout>
                <Box className={classes.header}>
                    <BottomNavigation
                        value={option}
                        onChange={(event, newValue) => {
                            setOption(newValue);
                        }}
                        showLabels
                        className={classes.nav}
                    >
                        <BottomNavigationAction className={classes.navAction} label="Conversa" icon={<ChatIcon />} />
                        <BottomNavigationAction className={classes.navAction} label="Conversas" icon={<QuestionAnswerIcon />} />
                    </BottomNavigation>
                </Box>
                <Box className={classes.content}>
                    {option === 0 ? renderMessageContext() : renderTicketsManagerTabs()}
                </Box>
            </TicketAdvancedLayout>
        </QueueSelectedProvider>
    );
};

export default TicketAdvanced;
